import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import Grid from "../Utils/Grid";
import ModalUser from "./Modal/ModalUser";
import StationInfoModal from "./Modal/StationInfoModal";
import CountdownRenderer from "./CountdownRenderer";
import qr_code_white from "../../../../assets/img/qrblanco.svg";
import moment from "moment";
import CustomSelectFIeld from "../Utils/FieldFilters/SelectField/SelectFIeld";
import Filters from "../Utils/Filters/Filters";
import { ROLE_ADMIN, HUMAN_RESOURCES, ROLE_ADMIN_STATION } from "../../../utility/constants";
import "./qr-scan.css";

const QRScan = ({
    customUserList,
    data,
    modal_open,
    setOpenModal,
    user_QR,
    setEntry,
    setExit,
    loader,
    qrRead,
    filterUserQR,
    user_filter_qr,
    page,
    station,
    setStation,
    me,
}) => {
    const pageRef = useRef(page);

    useEffect(() => {
        pageRef.current = page;
    }, [page]);
    const [showObservation, setShowObservation] = useState(false);

    // New State for Station Info Modal
    const [stationModalOpen, setStationModalOpen] = useState(false);
    const [selectedStationInfo, setSelectedStationInfo] = useState(null);

    useEffect(() => {
        customUserList(); // Initial load with loader

        // Poll every 30 seconds for real-time status updates (Silent)
        const interval = setInterval(() => {
            customUserList(pageRef.current, false);
        }, 30000);

        return () => clearInterval(interval);
    }, []);

    const toggleStationModal = () => setStationModalOpen(!stationModalOpen);

    const columns = [
        {
            dataField: "first_name",
            text: "Nombre",
            formatter: (cell, row) => `${cell} ${row.last_name}`,
        },
        {
            dataField: "no_dpi",
            text: "DPI",
        },
        {
            dataField: "firefighter_type",
            text: "Tipo de bombero",
            formatter: (cell, row) =>
                `${row.firefighter_type
                    ? row.firefighter_type
                    : "Sin tipo de bombero"
                }`,
        },
        {
            dataField: "last_entry",
            text: "Último ingreso",
            formatter: (cell, row) => `${row.last_entry
                ? moment(row.last_entry).tz("America/Guatemala").format("DD-MM-YYYY HH:mm:ss")
                : "Sin registro"
                }`,
        },
        {
            dataField: "remaining_time",
            text: "Tiempo Restante",
            formatter: (cell, row) => {
                if (!row.is_entry || !row.last_entry || !row.station_info || !row.station_info.hours_limit || isNaN(row.station_info.hours_limit)) {
                    return <span className="text-muted">-</span>;
                }
                return (
                    <CountdownRenderer
                        entryDate={row.last_entry}
                        hoursLimit={row.station_info.hours_limit}
                    />
                );
            }
        },
        {
            dataField: "last_exit",
            text: "Última salida",
            formatter: (cell, row) => `${row.last_exit
                ? moment(row.last_exit).tz("America/Guatemala").format("DD-MM-YYYY HH:mm:ss")
                : "Sin registro"
                }`,
        },
        {
            dataField: "is_entry",
            text: "Estado",
            formatter: (cell, row) => {
                let colorClass = "status-point-orange";
                let text = "Sin registro";

                if (row.is_entry === false) {
                    colorClass = "status-point-red";
                    text = "Salida";
                } else if (row.is_entry === true) {
                    colorClass = "status-point-green";
                    text = "Ingreso";
                }

                return (
                    <div className="d-flex align-items-center">
                        <span className={`status-point ${colorClass}`}></span>
                        <span className="status-text">{text}</span>
                    </div>
                );
            },
        },
        {
            dataField: "id",
            text: "Acciones",
            formatter: (cell, row) => (
                <div className="d-flex align-items-center">
                    <button
                        className="btn btn-info btn-sm mr-2 p-1"
                        onClick={() => {
                            setSelectedStationInfo(row.station_info);
                            setStationModalOpen(true);
                        }}
                        title="Ver Info Estación"
                        style={{ width: '30px', height: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    >
                        <i className="material-icons" style={{ fontSize: '18px', color: 'white' }}>remove_red_eye</i>
                    </button>

                    <button
                        disabled={row.is_entry === false}
                        className="qr-action-btn-blue p-0"
                        onClick={() => {
                            setShowObservation(true);
                            qrRead(row.id, false);
                        }}
                        title="Escanear Salida"
                    >
                        <span className="material-icons">
                            <img src={qr_code_white} alt="QR Scan" style={{ width: '20px', height: '20px' }} />
                        </span>
                    </button>
                </div>
            ),
        },
    ];

    return (
        <div className="qr-scan-page-container">
            <ModalUser
                setOpenModal={setOpenModal}
                modal_open={modal_open}
                data={user_QR}
                setEntry={setEntry}
                setExit={setExit}
                loader={loader}
                showObservation={showObservation}
            />

            <StationInfoModal
                isOpen={stationModalOpen}
                toggle={toggleStationModal}
                data={selectedStationInfo}
            />

            {/* Header */}
            <div className="qr-scan-page-header">
                <div className="header-left">
                    <div className="title-section">
                        <h1>Escaneo de QR</h1>
                        <p className="subtitle">Listado General De Registros De Escaneo De QR</p>
                    </div>
                </div>
                <a href="/#/qr_read" className="qr-scan-create-btn">
                    <img src={qr_code_white} alt="Scan Icon" style={{ width: '20px', height: '20px' }} />
                    Escanear QR
                </a>
            </div>

            {/* Filters Card */}
            <div className="qr-scan-filters-card mb-3">
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '16px', alignItems: 'center' }}>
                    <div className="qr-scan-filter-wrapper" style={{ minWidth: '0' }}>
                        <span className="material-icons filter-icon left">filter_alt</span>
                        <CustomSelectFIeld
                            name="user"
                            labelKey="first_name"
                            labelKey2="last_name"
                            valueKey="id"
                            nameApiOptions="qr"
                            placeholder="Usuario"
                            value={user_filter_qr}
                            setValue={filterUserQR}
                        />
                    </div>
                    {(me && (me.role === ROLE_ADMIN || me.role === HUMAN_RESOURCES)) && (
                        <div className="qr-scan-filter-wrapper" style={{ minWidth: '0' }}>
                            <Filters
                                station={{
                                    show: true,
                                    station: station,
                                    setStation: setStation,
                                    classNameFilter: "",
                                }}
                            />
                        </div>
                    )}
                </div>
            </div>

            {/* Table Card */}
            <div className="qr-scan-table-card">
                <Grid
                    data={data}
                    loading={loader}
                    page={page}
                    columns={columns}
                    onPageChange={customUserList}
                    noDataMessage={"Sin Usuarios"}
                />
            </div>
        </div>
    );
};

export default QRScan;
